import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet, redirect } from '@tanstack/react-router';

import { ErrorBoundary } from '@/app/error-boundary';
import { AppProviders } from '@/app/providers/app-providers';
import { adminUserOptions } from '@/entities/admin-user';
import { isAuthError } from '@/shared/api/http-client';

function RootComponent() {
    return (
        <AppProviders>
            <Outlet />
        </AppProviders>
    );
}

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
    component: RootComponent,
    errorComponent: ErrorBoundary,
    beforeLoad: async ({ context: { queryClient }, location }) => {
        const isOnSignIn = location.pathname === '/sign-in';
        if (isOnSignIn) return;

        try {
            // Zero staleness forces a real /auth/me revalidation on every navigation —
            // ensureQueryData would accept a stale cached session up to 5 minutes old.
            await queryClient.fetchQuery({ ...adminUserOptions(), staleTime: 0 });
        } catch (error) {
            if (!isAuthError(error)) throw error;

            // `location.href` is path-only; the backend validates `returnUrl` as a full URL.
            throw redirect({
                to: '/sign-in',
                search: { returnUrl: `${window.location.origin}${location.href}` },
            });
        }
    },
});
